import {useFeatureFlag} from '@ezcater/feature-flags-react';

export const useDirectEntryMissingMenuItemFeatureFlag = () =>
  useFeatureFlag({featureFlag: 'EzManage:DirectEntryMissingMenuItem'});

export const useDirectEntrySalesTaxCodesFeatureFlag = () =>
  useFeatureFlag({featureFlag: 'DirectEntry:SalesTaxCodes'});

const useDisplayItemDescription = () =>
  useFeatureFlag({featureFlag: 'EzManage::DisplayItemDescription'});

const useDisallowItemDescriptionOnBrandIDs = () =>
  useFeatureFlag({featureFlag: 'EzManage::DisallowItemDescriptionOnBrandIDs'});

export const useShouldShowDisplayItemDescription = () => {
  const {enabled: shouldShowDisplayItemDescription} = useDisplayItemDescription();
  const {enabled: shouldHideItemDescriptionOnSelectBrandIDs} =
    useDisallowItemDescriptionOnBrandIDs();

  return shouldShowDisplayItemDescription && !shouldHideItemDescriptionOnSelectBrandIDs;
};

export const useEnableAppsFlyerBanner = () =>
  useFeatureFlag({featureFlag: 'EzManage::AppsFlyerBanner'});

export const useHidePayoneerTaxForm = () =>
  useFeatureFlag({featureFlag: 'EzManage::HidePayoneerTaxForm'});

export const useDisableFinalizedDirectEntryEditFeatureFlag = () =>
  useFeatureFlag({featureFlag: 'EzManage::DisableFinalizedDirectEntryEdit'});

export const useShowUsernameEmailConsolidationModal = () =>
  useFeatureFlag({featureFlag: 'EzManage::ShowUsernameEmailConsolidationModal'});

export const useCapacityImprovements = () =>
  useFeatureFlag({featureFlag: 'FX::CapacityImprovements'});

export const useAutoAccept = () => useFeatureFlag({featureFlag: 'FX::AutoAccept'});

export const useDisableDirectEntry = () =>
  useFeatureFlag({featureFlag: 'EzManage::DisableDirectEntry'});

export const useFoodReadyForPickup = () =>
  useFeatureFlag({featureFlag: 'FulfillmentExperience::FoodReadyForPickup'});

export const useEzManageHideDownloadImgButton = () =>
  useFeatureFlag({featureFlag: 'Promotions::EzManageHideDownloadImgButton'});

export const useShowActivityTab = () => useFeatureFlag({featureFlag: 'EzManage::ShowActivityTab'});

export const useDeprecateEzoPromos = () =>
  useFeatureFlag({featureFlag: 'Promotions::DeprecateEzoPromos'});

export const useCpTimeliness = () => useFeatureFlag({featureFlag: 'FX::CPTimeliness::Enabled'});

export const useCpTimelinessWarnOnly = () =>
  useFeatureFlag({featureFlag: 'FX::CPTimeliness::WarnOnly'});

export const useSponsoredListingCampaignOrders = () =>
  useFeatureFlag({featureFlag: 'EzManage::SponsoredListingsCampaignOrders'});

export const useSponsoredListingsReportDownload = () =>
  useFeatureFlag({featureFlag: 'EzManage::SponsoredListingsReportDownload'});

export const useSponsoredListingLocationsWithActiveCampaigns = () =>
  useFeatureFlag({featureFlag: 'EzManage::SponsoredListingLocationsWithActiveCampaigns'});

export const useSponsoredListingCanDeleteCampaigns = () =>
  useFeatureFlag({featureFlag: 'EzManage::SponsoredListingsCanDeleteCampaigns'});

export const useGuidedOnboardingNetNewSingleLocation = () =>
  useFeatureFlag({featureFlag: 'GuidedOnboarding::NetNewSingleLocation'});

export const useHideDeliveryPartnerPreferences = () =>
  useFeatureFlag({featureFlag: 'Delivery::HideDeliveryPartnerPreferences'});
